import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Badge, Swiper, ImageViewer, Toast } from 'antd-mobile'
import { modal } from '../../../../components/AiModal'
import { setUpdateUserScanNumber, setReportApproval } from '../../../../api/report'
import startReport from '../../../../utils/nativeFun/startReport'
import { getCreateMiniQrCode } from '../../../../api/common'
import getUserInfo from '../../../../utils/getUserInfo'
import car_icon from '@/images/car_icon.png'
import telPhoneByNumber from '../../../../utils/nativeFun/telPhoneByNumber'

import './index.scss'
import { useEffect } from 'react'

interface eventItem {
    detailsClick?: (props) => void // 点击详情事件
    pushClick?: (props) => void // 点击推送车主事件
    shareClick?: (props) => void // 点击分享车主事件
    scanClick?: (props) => void // 点击车主扫码事件
    auditClick?: (props) => void // 点击车主扫码事件
}

interface ListItemProps {
    eventOptions?: eventItem
    item?: any
    updateData?:(props:any) => void
    arrowUpStyle?: any
    isFollow?: boolean
    index?: number
    startTime?: string
    endTime?: string
}

const ListItem: React.FC<ListItemProps> = ({ isFollow = false, index = 0, startTime='', endTime='', item, eventOptions = {}, ...props}) => {
    const navigate = useNavigate()
    const [more, setMore] = useState(false)
    // 点击详情
    const handleDetailsClick = () => {
        if( !!eventOptions?.detailsClick ) {
            eventOptions.detailsClick(item)
            return
        }
        startReport(1, false, item.checkReportPk, () => {
            navigate(`/detection/info/${item.checkReportPk}`)
        })
    }

    const handlePushClick = async() => {
        if( !!eventOptions?.pushClick ) {
            eventOptions.pushClick(item)
            return
        }
        try {
            navigate(`/detection/info/${item.checkReportPk}`)
        } catch (error) {
            
        }
    }
    /**
     * 网页分享
     * @param url  地址
     * @param title 标题
     * @param description  描述
     * @param imgUrl  分享icon
     * @param judge  类型选择 好友-0 朋友圈-1
     * WxUrlShare(String url, String title, String description, String imgUrl, int judge)
     */
    const handleShareClick = async() => {
        if( !!eventOptions?.shareClick ) {
            eventOptions.shareClick(item)
            return
        }
        try {
            navigate(`/detection/info/${item.checkReportPk}`)
        } catch (error) {
            
        }
    }

    const handlescanClick = async() => {
        Toast.show({
            icon: 'loading',
            content: '加载中…',
            duration: 0,
            maskClickable:false,
        })
        if( !!eventOptions?.scanClick ) {
            Toast.clear()
            eventOptions.scanClick(item)
            return
        }
        try {
            //小程序码
            // if( window?.androidNative?.getUserInfo ) { 
                const orgPk = getUserInfo()?.orgPk
                const data:any = await getCreateMiniQrCode({
                    pageUrl:'pages/report/detection/info/index',
                    params:`u=${item.userPk}&orgPk=${orgPk}&checkReportPk=${item.checkReportPk}`
                })


                const img = `data:image/jpeg;base64,${data.data}`
                ImageViewer.Multi.show({
                    images:[img],
                    defaultIndex:0
                })
                const res:any = await setUpdateUserScanNumber(item.checkReportPk)
                if( props?.updateData ) {
                    props.updateData({
                        ...item,
                        userScanNumber:item.userScanNumber + 1
                    })
                }
            // }
            Toast.clear()
        } catch (error) {
            Toast.clear()
        }
    }
    
    const handleAudit = async() => {
        if( !!eventOptions?.auditClick ) {
            eventOptions.auditClick(item)
            return
        }
        modal({
            title:'提示',
            content:`是否确认审核检测报告[${item.specialName}]？`,
            okText:'审核',
            isLoading:true,
            onOk:() => {
                return new Promise(async(resolve,reject) => {
                    try {
                        const res:any = await setReportApproval(item.checkReportPk)
                        if( props?.updateData ) {
                            props.updateData({
                                ...item,
                                approvalStatus:'1'
                            })
                        }
                        resolve(true)
                    } catch (error) {
                        reject()
                    }
                })
            }
        })
    }

    const handleImageViewer = (image = '', imageList:any = []) => {
        if( !image ) {
            return
        }
        const _imageList = imageList.filter(item => item.type === '0').map(item => item.resourceUrl)
        ImageViewer.Multi.show({
            images:_imageList,
            defaultIndex:_imageList.findIndex(item => item === image)
        })
    }

    const handleMakePhoneCall = () => {
        if(window?.androidNative?.telPhoneByNumber && item?.phone) {
            window?.androidNative?.telPhoneByNumber(item?.phone)
        }else {
            telPhoneByNumber(item?.phone)
        }
    }
    
    return (
        <>
            <div className='report-detection-list-data-wrapper-item'>
                <h1 className='cy-arrow cy-arrow-right'>{index+1}、{item?.specialName} <span onClick={handleDetailsClick}>检测报告</span> </h1>
                <div className='report-detection-list-data-wrapper-item-license'>
                    <div className='img'><img src={item?.icon || car_icon} alt="" /></div>
                    <div className='license-wrapper'>
                        <div className='license-wrapper-brand'>
                            <b className='brand'>{item.brandName}</b>
                            <Badge content={item?.readCount || 0} bordered color='#068EEA'>
                                <div className='reading'>{['未阅读','已阅读'][item?.isRead || 0]}</div>
                            </Badge>
                            {!!item?.readUserList && !!item?.readUserList?.length && <div className='reading-img'>
                                {(item?.readUserList || []).map((item, index) => (
                                    <p key={index}><img src={item} alt="" /></p>
                                ))}
                            </div>}
                        </div>
                        <div className='license-wrapper-user'>
                            <span style={{'fontWeight':'bold','fontSize':'.3733rem'}}>{item.carNo}</span>
                            <span>{item.name}</span>
                            <p></p>
                            <b onClick={handleMakePhoneCall}>{item.phone}</b>
                            <p></p>
                            <span>{item?.mileage || 0}km</span>
                        </div>
                    </div>
                    <div className="detectionreport-score">
                        <img className={`detectionreport-score-wave ${['green', 'yellow', 'red'][(item?.checkReportMark > 60 && item?.checkReportMark < 90 ) ? 1 : item?.checkReportMark <= 60 ? 2 : 0 ]}`} src={`https://up.wlyinfo.com/miniprogram_public/wave/wave_bg_${['green', 'yellow', 'red'][(item?.checkReportMark >= 60 && item?.checkReportMark < 90 ) ? 1 : item?.checkReportMark < 60 ? 2 : 0 ]}.png`} />
                        <img className={`detectionreport-score-wave detectionreport-score-waves ${['green', 'yellow', 'red'][(item?.checkReportMark >= 60 && item?.checkReportMark < 90 ) ? 1 : item?.checkReportMark < 60 ? 2 : 0 ]}`} src={`https://up.wlyinfo.com/miniprogram_public/wave/wave_bg_${['green', 'yellow', 'red'][(item?.checkReportMark >= 60 && item?.checkReportMark < 90 ) ? 1 : item?.checkReportMark < 60 ? 2 : 0 ]}.png`} />
                        <div className="detectionreport-score-num">{item?.checkReportMark}<span>分</span></div>
                    </div>
                </div>
                <div className='test-status-wrapper'>
                    <div className='test-status-wrapper-item' style={{ '--color': '#B68D41', '--width':'1.6rem' }}>
                        <div>{item?.reportRewardVo?.checkReward || 0}</div>
                        <p>检测奖励</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#B68D41', '--width':'1.6rem' }}>
                        <div>{item?.reportRewardVo?.talkReward || 0}</div>
                        <p>开口奖励</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#B68D41', '--width':'1.6rem' }}>
                        <div>{item?.reportRewardVo?.conversionReward || 0}</div>
                        <p>转化奖励</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#B68D41', '--width':'1.6rem' }}>
                        <div>{item?.reportRewardVo?.followUpReward || 0}</div>
                        <p>跟进奖励</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#B68D41', '--width':'1.6rem' }}>
                        <div>{item?.reportRewardVo?.additionsReward || 0}</div>
                        <p>增项奖励</p>
                    </div>
                </div>
                <div className='test-status-wrapper'>
                    <div className='test-status-wrapper-item' style={{ '--color': '#333333' }}>
                        <div>{item.itemNum}</div>
                        <p>已检测</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#10C294' }}>
                        <div>{item.normalNum}</div>
                        <p>状态良好</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#FCAF02' }}>
                        <div>{item.slightNum}</div>
                        <p>密切关注</p>
                    </div>
                    <div className='test-status-wrapper-item' style={{ '--color': '#FC0700' }}>
                        <div>{item.seriousNum}</div>
                        <p>急需处理</p>
                    </div>
                </div>
                {!!item?.itemListVos?.length && <div className='matters-wrapper border'>
                    <div className='arrow-up' style={props?.arrowUpStyle || {}}></div>
                    {(item?.itemListVos || []).map((itemName, i) => (
                        <>
                            { i < (!more ? 1 : item?.itemListVos.length) && <div className='matters-wrapper-item' key={i}>
                                <h6>{i+1}.{itemName.itemName}</h6>
                                {(itemName?.paramListVos || []).map((vos, vosx) => (
                                    <div className='matters-wrapper-item-children'>
                                        <h5>{i+1}.{vosx+1} {vos.checkItemParamName}</h5>
                                        <div className='matters-wrapper-item-contrast'>
                                            <div><p><span>正常状态:</span><i>{vos?.checkItemParamNormalValue}</i></p></div>
                                            <div style={{'--color':['#10C294','#FCAF02','#FC0700'][vos.checkStatus]}}><p><span>检测结果:</span><b>{vos?.checkValue}</b></p></div>
                                        </div>
                                        {!!vos?.resourceListVos?.length && <div className='matters-wrapper-item-video'>
                                            <div className='video'>
                                                {/* <video style={{ 'width': '100%' }} controls controlsList="nodownload">
                                                    您的浏览器不支持 video 标签。
                                                    <source src='https://yme-res.aibiyme.cn/test/a2b96faeb02581770a4736f61bd3b6b7.mp4' type="video/mp4"></source>
                                                </video> */}
                                                {!!vos?.checkItemParamNormalImg && <img onClick={() => handleImageViewer(vos?.checkItemParamNormalImg, [{type:'0','resourceUrl':vos?.checkItemParamNormalImg}])} src={vos?.checkItemParamNormalImg} alt="" />}
                                            </div>
                                            <div className='image'>
                                                <Swiper 
                                                    indicator={(total, current) => <div className='customIndicator'>{`${current + 1} / ${total}`}</div>}
                                                    loop 
                                                    style={{'--width':'3.7867rem','--height':'2.6667rem'}}
                                                >
                                                    {(vos?.resourceListVos || []).map((src, srcx) => (
                                                        <Swiper.Item key={srcx}>
                                                            {src?.type === '0' && <img onClick={() => handleImageViewer(src.resourceUrl, vos?.resourceListVos)} src={src.resourceUrl} alt="" />}
                                                            {src?.type === '1' && <video controls controlsList="nodownload">
                                                                您的浏览器不支持 video 标签。
                                                                <source src={src.resourceUrl} type="video/mp4"></source>
                                                            </video>}
                                                        </Swiper.Item>
                                                    ))}
                                                </Swiper>
                                            </div>
                                        </div>}
                                    </div>
                                ))}
                            </div>}
                        </>
                    ))}
                    {(item?.itemListVos || []).length > 1 && <div className='report-more-wrapper' onClick={() => setMore(!more)}>{!more ? '展开' : '收起'}<img className={`${more ? 'b' : ''}`} src="https://up.wlyinfo.com/miniprogram_public/sort_icon_top_arrow.png" alt="" /></div>}
                </div>}
                <div className='last-follow-user-name'>
                    {!!item?.createBillTime && <p>检测开单: {item.createBillUserName} {item.createBillTime}</p>}
                    {!!item?.checkTime && <p>检测技师: {item.checkUserName} {item.checkTime}</p>}
                    {!!item?.userConfirmTime && <p>车主确认: {item.name} {item.userConfirmTime}</p>}
                    {/* {item.followUpStatus === '1' && <div className='follow-wrapper'>
                        {!!item?.followUpRewardAmount && <h1>奖励:{item?.followUpRewardAmount}元</h1>}
                        <div className='follow-wrapper-btn' onClick={() => navigate(`/follow/operation?checkReportPk=${item.checkReportPk}&size=${index + 10}&startTime=${startTime}&endTime=${endTime}`)}>立即跟进</div>
                    </div>}
                    {!!item.lastFollowUpTime && <p>上次跟进: {item.lastFollowUpUserName} {item.lastFollowUpTime}</p>} */}
                </div>
                {!isFollow && <div className='report-detection-list-data-wrapper-item-btn'>
                    {item.approvalStatus === '1' && <>
                        <Badge content={item?.pushUserNumber || 0} bordered color='#333'>
                            <p className='border' onClick={handlePushClick}>推送车主</p>
                        </Badge>
                        <Badge content={item?.shareUserNumber || 0} bordered color='#333'>
                            <p className='border' onClick={handleShareClick}>分享车主</p>
                        </Badge>
                        <Badge content={item?.userScanNumber || 0} bordered color='#333'>
                            <p className='border' onClick={handlescanClick}>车主扫码</p>
                        </Badge>
                    </>}
                    {item.approvalStatus === '0' && <Badge bordered color='#333'>
                        <p className='border' onClick={handleAudit}>审核报告</p>
                    </Badge>}
                </div>}
            </div>
        </>
    )
}

export default ListItem